import Vue from 'vue'
import Router from 'vue-router'
import AsyncComponent from './asyncComponent.js'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@layouts/index.vue'),
      children: [
        {
          path: 'official-account/login',
          name: 'official-account/login',
          component: () => import('@pages/OfficialAccount/login.vue')
        },
        {
          path: 'official-account/collect',
          component: () => import('@pages/OfficialAccount/collect.vue')
        }
      ]
    },
    {
      path: '/basic-mobile',
      name: 'basic-mobile',
      component: () => import('@layouts/index.vue'),
      children: [
        {
          path: 'sweepcode',
          name: 'sweepcode',
          component: () => import('@pages/SweepCode/Index/index.vue')
        }
      ]
    },
    {
      path: '/official-account',
      name: 'official-account',
      component: () => import('@layouts/OfficialAccount.vue'),
      redirect: 'official-account/manager',
      children: [
        {
          path: 'open',
          component: AsyncComponent({ loadFunc: () => import('@pages/OfficialAccount/index.vue'), loadModel: () => import('@pages/OfficialAccount/model/index.js') })
        },
        {
          path: 'manager',
          component: () => import('@pages/OfficialAccount/manager.vue')
        },
        {
          path: 'personal',
          component: () => import('@pages/OfficialAccount/personal.vue')
        },
        {
          path: 'invoice-info',
          component: () => import('@pages/OfficialAccount/invoiceInfo.vue')
        }
      ]
    },
    {
      path: '*',
      name: 'NotFount',
      component: () => import('@pages/NotFound.vue')
    }
  ]
})
